var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeavySnow01 = function SvgHeavySnow01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heavy_snow-01_svg2__a",
    x1: -0.65,
    x2: 153.33,
    y1: 157.09,
    y2: 17.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow-01_svg2__a",
    id: "heavy_snow-01_svg2__b",
    x1: 40.31,
    x2: 194.29,
    y1: 202.43,
    y2: 63.33
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow-01_svg2__a",
    id: "heavy_snow-01_svg2__c",
    x1: 52.64,
    x2: 206.61,
    y1: 216.07,
    y2: 76.97
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow-01_svg2__a",
    id: "heavy_snow-01_svg2__d",
    x1: 70.41,
    x2: 224.39,
    y1: 235.75,
    y2: 96.64
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow-01_svg2__a",
    id: "heavy_snow-01_svg2__e",
    x1: 68.78,
    x2: 222.75,
    y1: 233.94,
    y2: 94.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow-01_svg2__a",
    id: "heavy_snow-01_svg2__f",
    x1: 29.14,
    x2: 183.12,
    y1: 190.07,
    y2: 50.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow-01_svg2__a",
    id: "heavy_snow-01_svg2__g",
    x1: 37.12,
    x2: 191.1,
    y1: 198.9,
    y2: 59.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow-01_svg2__a",
    id: "heavy_snow-01_svg2__h",
    x1: 16.66,
    x2: 170.63,
    y1: 176.25,
    y2: 37.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow-01_svg2__a",
    id: "heavy_snow-01_svg2__i",
    x1: 7.97,
    x2: 161.94,
    y1: 166.63,
    y2: 27.52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow-01_svg2__a",
    id: "heavy_snow-01_svg2__j",
    x1: 56.89,
    x2: 210.87,
    y1: 220.79,
    y2: 81.68
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M144.75 24.72c-2.75 0-5.56.37-8.53 1.13C128.98 10.05 113.48 0 95.98 0 76.6 0 59.61 12.4 53.7 30.86c-.54 1.67.38 3.46 2.05 3.99a3.16 3.16 0 0 0 3.99-2.05C64.8 16.98 79.37 6.35 95.98 6.35c14.76 0 27.86 8.36 34.19 21.55-4.36 1.99-7.37 4.93-9.22 7.28a3.18 3.18 0 0 0 .53 4.46c.58.46 1.27.68 1.96.68.94 0 1.87-.42 2.49-1.21 1.72-2.18 4.73-5.06 9.34-6.38.02 0 .09-.02.11-.03 3.38-1.1 6.45-1.64 9.37-1.64 16.77 0 30.41 13.64 30.41 30.42s-13.64 30.41-30.41 30.41H47.74c-12.63 0-22.91-10.28-22.91-22.91s10.28-22.91 22.91-22.91c1.87 0 3.82.3 6.13.95 3.04.92 5.86 2.56 7.94 4.63.62.62 1.43.92 2.24.92s1.63-.31 2.25-.94a3.175 3.175 0 0 0-.01-4.49c-2.81-2.8-6.58-5.01-10.61-6.22h-.03s-.02-.01-.03-.01c-2.91-.82-5.41-1.2-7.88-1.2-16.13 0-29.26 13.12-29.26 29.26S31.6 98.22 47.74 98.22h97.01c20.27 0 36.76-16.49 36.76-36.76S165.02 24.7 144.75 24.7",
    style: {
      fill: "url(#heavy_snow-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.26 119.39a2.12 2.12 0 0 0-2.9-.78l-5.91 3.41 1.24-4.62c.3-1.13-.37-2.3-1.5-2.6-1.14-.29-2.3.37-2.6 1.5l-2.34 8.73-4.55 2.63a9 9 0 0 0-4.33-2.5v-5.17l6.39-6.39c.83-.83.83-2.18 0-3.01s-2.18-.83-3.01 0l-3.38 3.38v-6.91c0-1.17-.95-2.13-2.13-2.13s-2.13.95-2.13 2.13v6.9l-3.38-3.38a2.13 2.13 0 0 0-3.01 0 2.13 2.13 0 0 0 0 3.01l6.39 6.39v5.17a9 9 0 0 0-4.34 2.5l-4.47-2.58-2.34-8.73c-.3-1.13-1.47-1.8-2.61-1.5-1.13.3-1.81 1.47-1.5 2.6l1.24 4.62-5.99-3.46a2.116 2.116 0 0 0-2.9.78c-.59 1.02-.24 2.32.78 2.9l5.98 3.45-4.62 1.24c-1.13.3-1.81 1.47-1.5 2.6a2.13 2.13 0 0 0 2.6 1.51l8.73-2.34 4.5 2.6c-.23.8-.4 1.63-.4 2.5s.16 1.69.39 2.48l-4.48 2.59-8.73-2.34c-1.14-.29-2.3.37-2.6 1.5s.37 2.3 1.5 2.6l4.62 1.24-5.99 3.46a2.127 2.127 0 0 0-.78 2.9 2.127 2.127 0 0 0 2.9.78l5.98-3.45-1.24 4.62c-.3 1.14.37 2.3 1.5 2.61 1.16.3 2.31-.39 2.6-1.5l2.34-8.73 4.47-2.58a8.96 8.96 0 0 0 4.34 2.5v5.24l-6.39 6.39a2.13 2.13 0 0 0 0 3.01c.83.83 2.18.83 3.01 0l3.38-3.38v6.84c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-6.82l3.38 3.38c.83.83 2.18.83 3.01 0s.83-2.18 0-3.01l-6.39-6.39v-5.25a8.96 8.96 0 0 0 4.34-2.5l4.53 2.62 2.34 8.73c.3 1.11 1.44 1.81 2.61 1.5 1.13-.3 1.81-1.47 1.5-2.6l-1.24-4.62 5.92 3.42c1.01.59 2.32.24 2.9-.78.59-1.02.24-2.32-.78-2.9l-5.91-3.41 4.62-1.24c1.13-.3 1.81-1.47 1.5-2.6-.3-1.13-1.46-1.8-2.61-1.5l-8.73 2.34-4.56-2.63c.23-.79.39-1.62.39-2.48s-.16-1.7-.4-2.5l4.55-2.63 8.73 2.34a2.122 2.122 0 0 0 2.6-1.51c.3-1.13-.37-2.3-1.5-2.6l-4.62-1.24 5.92-3.42c1.02-.59 1.36-1.89.78-2.9m-25 19.14c-2.59 0-4.7-2.11-4.7-4.71s2.11-4.72 4.7-4.72 4.72 2.12 4.72 4.72-2.12 4.71-4.72 4.71",
    style: {
      fill: "url(#heavy_snow-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.2 119.31c-1.17 0-2.13.95-2.13 2.13v7.57c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13",
    style: {
      fill: "url(#heavy_snow-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.26 148.67c-1.17 0-2.13.95-2.13 2.13v7.57c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13",
    style: {
      fill: "url(#heavy_snow-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.53 167.73c-1.17 0-2.13.95-2.13 2.13v7.57c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13",
    style: {
      fill: "url(#heavy_snow-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.62 142.17c-1.17 0-2.13.95-2.13 2.13v7.57c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13",
    style: {
      fill: "url(#heavy_snow-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.78 176.12c-1.17 0-2.13.95-2.13 2.13v7.57c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13",
    style: {
      fill: "url(#heavy_snow-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.74 149.48c-1.17 0-2.13.95-2.13 2.13v7.57c0 1.17.95 2.13 2.13 2.13s2.13-.95 2.13-2.13v-7.57c0-1.17-.95-2.13-2.13-2.13",
    style: {
      fill: "url(#heavy_snow-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.93 138.43c1.33 0 2.42-1.08 2.42-2.42v-8.48l8.49 4.9c1.15.67 2.64.27 3.3-.88.67-1.16.27-2.63-.88-3.3l-8.49-4.9 7.34-4.24a2.41 2.41 0 0 0 .88-3.3 2.42 2.42 0 0 0-3.3-.89l-7.34 4.24v-9.8c0-1.33-1.08-2.42-2.42-2.42s-2.42 1.08-2.42 2.42v9.8l-7.34-4.24a2.413 2.413 0 0 0-3.3.89c-.67 1.16-.27 2.63.88 3.3l7.34 4.24-8.49 4.9a2.41 2.41 0 0 0-.88 3.3 2.41 2.41 0 0 0 3.3.88l8.49-4.9v8.48c0 1.34 1.08 2.42 2.42 2.42",
    style: {
      fill: "url(#heavy_snow-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.66 200c1.33 0 2.42-1.08 2.42-2.42v-8.48l8.49 4.9c1.15.67 2.64.27 3.3-.88.67-1.16.27-2.63-.88-3.3l-8.49-4.9 7.34-4.24a2.41 2.41 0 0 0 .88-3.3 2.42 2.42 0 0 0-3.3-.89l-7.34 4.24v-9.8c0-1.33-1.08-2.42-2.42-2.42s-2.42 1.08-2.42 2.42v9.8l-7.34-4.24a2.413 2.413 0 0 0-3.3.89c-.67 1.16-.27 2.63.88 3.3l7.34 4.24-8.49 4.9a2.41 2.41 0 0 0-.88 3.3 2.41 2.41 0 0 0 3.3.88l8.49-4.9v8.48c0 1.34 1.08 2.42 2.42 2.42",
    style: {
      fill: "url(#heavy_snow-01_svg2__j)"
    }
  }));
};
export default SvgHeavySnow01;